import { get } from 'lodash';
import { ComponentType } from 'react';
import { TextField } from 'react-admin';

export type ExportFn = (
  record: any,
) => string | number | boolean | null | undefined;

export type ConfigurableColumns = {
  label: string;
  source: string;
  key?: string;
  sortBy?: string;
  omit?: boolean;
  GridComponent?: ComponentType<any>;
  gridComponentProps?: Record<string, any>;
  exportFn?: ExportFn | false;
  sortable?: boolean;
};

export const renderOmitList = (columns: ConfigurableColumns[]) =>
  columns.filter(({ omit }) => omit).map(({ source }) => source);

export const renderSortableFields = (
  columns: ConfigurableColumns[],
) =>
  columns
    .filter(({ sortable }) => sortable !== false)
    .map(({ source }) => source);

export const renderGridColumns = (columns: ConfigurableColumns[]) =>
  columns.map(
    ({
      label,
      source,
      key = source,
      sortBy,
      sortable = false,
      GridComponent = TextField,
      gridComponentProps,
    }) => (
      <GridComponent
        key={key}
        source={source}
        {...(sortBy ? { sortBy } : {})}
        label={label}
        sortable={sortable}
        {...gridComponentProps}
      />
    ),
  );

export const renderExportColumns = (
  columns: ConfigurableColumns[],
): [string, ExportFn][] =>
  columns
    .filter(({ exportFn }) => exportFn !== false)
    .map(({ label, source, exportFn }) => {
      const usableFn = exportFn || (record => get(record, source));

      return [label, usableFn] as const;
    });
